import {FeatureId} from '@client/constants/features';

export default class GoalSettings {
  constructor() {
    this.showCurrentPortfolio = null;
    this.showTargetPortfolio = null;
    this.showWealthProjection = null;
    this.canBeModified = null;
    this.canAttachAccount = null;
    this.totalCashImage = null;
    this.totalValueImage = null;
    this.showTotalCash = null;
  }

  loadData(payload) {
    if (!payload) {
      return;
    }

    this.canBeModified = payload.find((setting) => setting.id === FeatureId.ADD_EDIT_DELETE_GOAL)?.value;
    this.canAttachAccount = payload.find((setting) => setting.id === FeatureId.ATTACH_ACCOUNT)?.value;
    this.showTotalCash = payload.find((setting) => setting.id === FeatureId.TOTAL_GOALS_CASH_BOX)?.value;
    this.showCurrentPortfolio = payload.find((setting) => setting.id === FeatureId.CURRENT_PORTFOLIO_GOAL)?.value;
    this.showTargetPortfolio = payload.find((setting) => setting.id === FeatureId.TARGET_PORTFOLIO_GOAL)?.value;
    this.showWealthProjection = payload.find((setting) => setting.id === FeatureId.WEALTH_PROJECTION_GOAL)?.value;
  }
}
